/**
 * @function save
 * @description This handles saving a cookie in the browser and in memory/headers for server
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultBrowserOpts: function() {
        return defaultBrowserOpts;
    },
    defaultExpressOpts: function() {
        return defaultExpressOpts;
    },
    defaultHapiOpts: function() {
        return defaultHapiOpts;
    },
    defaultFastifyOpts: function() {
        return defaultFastifyOpts;
    },
    default: function() {
        return _default;
    }
});
var _encoding = require("./encoding");
var _util = require("./util");
var cookie = require("cookie");
var whiteListOpts = [
    "domain",
    "expires",
    "path",
    "secure",
    "httpOnly",
    "sameSite"
];
var defaultBrowserOpts = {
    path: "/",
    secure: true
};
var defaultExpressOpts = {
    path: "/",
    secure: true
};
var defaultHapiOpts = {
    path: "/",
    isSecure: true
};
var defaultFastifyOpts = {
    path: "/",
    secure: true
};
var _default = function(name, val) {
    var opt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, res = arguments.length > 3 ? arguments[3] : void 0;
    // const options = _pick(opt, whiteListOpts);
    var options = Object.keys(opt).reduce(function(acc, key) {
        if (whiteListOpts.includes(key)) {
            acc[key] = opt[key];
        }
        return acc;
    }, {});
    // browser
    if (typeof document !== "undefined") {
        document.cookie = cookie.serialize(name, (0, _encoding.encode)(val), Object.assign({}, defaultBrowserOpts, options));
        return;
    }
    // express
    if ((0, _util.isResWritable)(res) && res.cookie) {
        res.cookie(name, (0, _encoding.encode)(val), Object.assign({}, defaultExpressOpts, options));
        return;
    }
    // hapi
    if ((0, _util.isResWritable)(res) && res.state) {
        if (typeof options.secure !== "undefined") {
            options.isSecure = options.secure;
        }
        res.state(name, (0, _encoding.encode)(val), Object.assign({}, defaultHapiOpts, options));
        return;
    }
    // fastify
    if ((0, _util.isResWritable)(res) && res.setCookie) {
        res.setCookie(name, (0, _encoding.encode)(val), Object.assign({}, defaultFastifyOpts, options));
    }
};
